import React from 'react'

const Location = () => {
  return (
    <div>
      location
    </div>
  )
}

export default Location
